declare namespace $ {

	type $mol_view__sub_exso_sheets_site_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_exso_sheets_site_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_card__content_exso_sheets_site_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['content'] >
	>
	type __exso_sheets_site_4 = $mol_type_enforce<
		Parameters< $exso_sheets_site['device_columns'] >[0]
		,
		Parameters< ReturnType< $exso_sheets_site['Devices'] >['item_columns'] >[0]
	>
	type $mol_link__arg_exso_sheets_site_5 = $mol_type_enforce<
		ReturnType< $exso_sheets_site['_device_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_exso_sheets_site_6 = $mol_type_enforce<
		ReturnType< $exso_sheets_site['device_columns'] >
		,
		ReturnType< $mol_link['sub'] >
	>
	type $exso_table__title_exso_sheets_site_7 = $mol_type_enforce<
		string
		,
		ReturnType< $exso_table['title'] >
	>
	type $exso_table__items_exso_sheets_site_8 = $mol_type_enforce<
		ReturnType< $exso_sheets_site['devices'] >
		,
		ReturnType< $exso_table['items'] >
	>
	type $exso_table__columns_meta_exso_sheets_site_9 = $mol_type_enforce<
		ReturnType< $exso_sheets_site['columns_meta'] >
		,
		ReturnType< $exso_table['columns_meta'] >
	>
	type $exso_table__columns_exso_sheets_site_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $exso_table['columns'] >
	>
	type $exso_table__Item_exso_sheets_site_11 = $mol_type_enforce<
		ReturnType< $exso_sheets_site['Device_row'] >
		,
		ReturnType< $exso_table['Item'] >
	>
	type $mol_check_box__title_exso_sheets_site_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_exso_sheets_site_13 = $mol_type_enforce<
		ReturnType< $exso_sheets_site['blowings_all'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $exso_table__title_exso_sheets_site_14 = $mol_type_enforce<
		string
		,
		ReturnType< $exso_table['title'] >
	>
	type $exso_table__items_exso_sheets_site_15 = $mol_type_enforce<
		ReturnType< $exso_sheets_site['blowings'] >
		,
		ReturnType< $exso_table['items'] >
	>
	type $exso_table__tools_exso_sheets_site_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $exso_table['tools'] >
	>
	type $exso_table__reverse_exso_sheets_site_17 = $mol_type_enforce<
		boolean
		,
		ReturnType< $exso_table['reverse'] >
	>
	type $exso_table__columns_meta_exso_sheets_site_18 = $mol_type_enforce<
		ReturnType< $exso_sheets_site['columns_meta'] >
		,
		ReturnType< $exso_table['columns_meta'] >
	>
	type $exso_table__columns_exso_sheets_site_19 = $mol_type_enforce<
		ReturnType< $exso_sheets_site['blowing_columns'] >
		,
		ReturnType< $exso_table['columns'] >
	>
	export class $exso_sheets_site extends $mol_page {
		info_title( ): string
		Info_title( ): $mol_view
		meta( ): string
		Info_meta( ): $mol_view
		Info( ): $mol_card
		all_shifts( ): readonly($exso_sheets_shift)[]
		shifts( ): ReturnType< $exso_sheets_site['all_shifts'] >
		devices( ): ReturnType< $exso_sheets_site['shifts'] >
		shifts_map( ): ReturnType< ReturnType< $exso_sheets_site['Devices'] >['items_map'] >
		columns_meta( id: any): Record<string, any>
		device_columns( id: any): ReturnType< ReturnType< $exso_sheets_site['Devices'] >['item_columns'] >
		device_arg( id: any): Record<string, any>
		_device_arg( id: any): ReturnType< $exso_sheets_site['device_arg'] >
		Device_row( id: any): $mol_link
		Devices( ): $exso_table
		all_blowings( ): readonly($exso_sheets_blowing)[]
		blowings( ): ReturnType< $exso_sheets_site['all_blowings'] >
		blowings_all( next?: boolean ): boolean
		Blowings_tools( ): $mol_check_box
		blowing_columns( ): readonly(any)[]
		Blowings( ): $exso_table
		site_arg( id: any): Record<string, any>
		body( ): readonly(any)[]
		blowing_columns_all( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=site.view.tree.d.ts.map